// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_5093b4e0","outerContainer":"_7b9d8713","secondaryToolbar":"c85028be","doorHangerRight":"_5b7ff28b","toolbarContainer":"e2af0122","toolbarViewerMiddle":"_2b313902","progressBar":"_36cc64c2","back-to-application":"_03d347c1","section":"_0c9494a8","primarySubscriberTitle":"_74bb30a5","additionalInsurancesTitle":"c592cf77","icon":"_70d71b00","divider":"_68fa7b6c","toggleBtn":"c0a74ff8","withoutAdditionalInsurances":"cb8681f8","title":"_2083179b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InsurancesInfo/index.styl
// module id = 5006
// module chunks = 39